import(/* webpackMode: "eager", webpackExports: ["MenuDetailClient"] */ "/vercel/path0/apps/web/app/(app)/menu/[menuId]/MenuDetailClient.tsx");
